import { Button, styled } from '@mui/material';
import { useSelector } from 'react-redux';
import LocalStorage from '../../defined/localStorage';

const brand = JSON.parse(LocalStorage.getItem('branding'));

export const PageBox = styled('div')(({ theme }) => ({
  position: 'relative',

  overflowY: 'auto',
  '& .MuiContainer-root': {
    background: 'white',
    padding: 'var(--sp-md2)'
  },
  '& .od-title': {
    fontSize: 'calc(var(--fs-xl)*1.4150943)',
    lineHeight: '100%',
    fontWeight: 500,
    color: '#111827'
  },
  '& .od-sectionTitle': {
    fontSize: 'var(--fs-body)',
    lineHeight: '100%',
    fontWeight: 600,
    color: '#111827'
  },
  '& .od-name': {
    fontSize: 'var(--fs-body)',
    fontWeight: 400,
    color: '#111827'
  },
  '& .od-card': {
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    padding:
      'calc(var(--sp-xs)*1.5) calc(var(--sp-lg)*1.45) calc(var(--sp-xxs)*3) calc(var(--sp-md2)*1.5)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 'var(--sp-md)'
  },
  '& .od-spacer-sm': {
    marginTop: '8px',
    marginBottom: '8px'
  },
  '& .od-spacer-md': {
    marginTop: '12px',
    marginBottom: '12px'
  },
  '& .ordername': {
    fontSize: 'var(--fs-lg)',
    fontWeight: '600',
    color: '#383938'
  },
  '& .productimg': {
    backgroundColor: '#E5E7EB',
    width: '100%',
    height: '350px',
    borderRadius: 'var(--sp-md2)'
  },
  '& .productslideimg': {
    backgroundColor: '#E5E7EB',
    width: '100%',
    height: '90px',
    borderRadius: 'var(--sp-md2)'
  },
  '& .addproductimg': {
    backgroundColor: '#E5E7EB',
    width: '100%',
    height: '90px',
    fontSize: 'var(--fs-hero)',
    margin: 'var(--sp-md2) 0',
    borderRadius: 'var(--sp-md2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  '& .useravatar': {
    background: '#F3F4F6',
    color: '#6B7280',
    width: '28px',
    height: '28px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': { fontSize: 'var(--fs-lg)' },
    '& img': { width: '100%', height: '100%' }
  },
  '& .contact-icon': {
    width: '1em',
    height: '1em',
    fontSize: 'var(--fs-sm)',
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    display: 'inline-block',
    marginTop: 'var(--sp-xxs)'
  },
  '& .userinfo': {
    display: 'flex',
    gap: 'var(--sp-md2)',
    alignItems: 'flex-start',
    flex: '1 1 0',
    minWidth: 0
  },
  '& .contact-row': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'calc(var(--sp-sm) * 4)',
    alignItems: 'center',
    flexWrap: 'nowrap',
    minWidth: 0
  },
  '& .usercontact': {
    fontSize: 'var(--fs-sm2)',
    fontWeight: 400,
    color: '#111827',
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'initial',
    wordBreak: 'break-word',
    minWidth: 0
  },
  '& .usercontact.wrap': {
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'initial'
  },
  '& .business-name-link': {
    color: '#1890ff',
    cursor: 'pointer',
    '&:hover': { color: '#40a9ff', textDecoration: 'underline' }
  },
  '& .quote-service-group': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 'var(--sp-lg)',
    width: 'fit-content',
    flexWrap: 'nowrap'
  },

  '& .quote-service-group .info-item': {
    flex: '0 0 auto',
    minWidth: 'fit-content'
  },
  '& .order-details': {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--sp-lg)'
  },
  '& .info-row': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'calc(var(--sp-sm) * 4)',
    flexWrap: 'nowrap',
    minWidth: 0
  },
  '& .info-item': {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    gap: 'var(--sp-xs)',
    flex: '1 1 0',
    minWidth: 0
  },
  '& .info-row > .info-item:first-child': {
    flex: '1 1 0'
  },
  '& .info-row > .info-item:last-child': {
    flex: '1 1 0'
  },
  '& .orderdetails': {
    width: '100%',
    padding: 'var(--sp-md2)'
  },
  '& .groupText': {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--sp-xs)',
    margin: '20px 0'
  },

  '& .label': {
    fontSize: 'var(--fs-md)',
    lineHeight: '100%',
    fontWeight: 500,
    color: '#6E6F81'
  },
  '& .value': {
    fontSize: 'var(--fs-sm2)',
    'white-space': 'normal',
    overflow: 'visible',
    'text-overflow': 'initial',
    wordBreak: 'break-word',
    fontWeight: '400',
    color: '#000000'
  },
  '& .sub-value': {
    fontSize: 'var(--fs-xs)',
    'white-space': 'normal',
    overflow: 'visible',
    'text-overflow': 'initial',
    wordBreak: 'break-word',
    fontWeight: '400'
  },
  '& .value-stack': {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--sp-xxs)',
    minWidth: 0
  },
  '& .value-text': {
    fontSize: 'var(--fs-sm2)',
    fontWeight: 400,
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'initial',
    wordBreak: 'break-word',
    minWidth: 0,
    maxWidth: '100%'
  },
  '& .value-text.wrap': {
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'initial'
  },
  '& .value-stack .copy-icon': {
    marginLeft: 0
  },
  '& .action': {},
  '& .copy-icon': {
    cursor: 'pointer',
    marginLeft: '4px',
    color: 'inherit',
    height: 'var(--fs-lg)',
    width: 'var(--fs-lg)',
    display: 'inline-block',
    transition: 'color 120ms ease'
  },
  '& .copy-icon.copied, & .copy-icon.copied svg': {
    color: '#ffa500'
  },
  '& .detals': {
    width: '40%'
  },
  '& .slick-dots': {
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: ' space-between !important',
    width: '100% !important',
    position: 'initial !important',
    margin: 'auto'
  },
  '& .slick-slide': {
    '& img': {
      height: '250px !important'
    }
  },
  '.slick-dots li': {
    width: '90% !important'
  },
  '& .slick-next': {
    right: '35px !important'
  },
  '.slick-next:before, .slick-prev:before': {
    color: 'black'
  },
  '& .slick-prev, .slick-next': {
    top: '36% !important'
  },
  '& .slick-prev': {
    left: '35px !important'
  },

  '& .slick-dots li': {
    height: 'auto'
  },
  '& .slick-dots li:first-child': {
    textAlign: '-webkit-right !important'
  },
  '& .messages_box': {
    borderRadius: 'var(--sp-md2)',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    boxSizing: 'border-box',

    '& .chat_box': {
      border: '1px solid #DADADA',
      marginTop: 'calc(var(--sp-md2)*1.7)',
      flex: 1,
      overflowY: 'auto',
      maxHeight: '100%',
      position: 'relative',
      borderRadius: 'var(--sp-xs)',
      overflowY: 'auto',
      padding:
        'calc(var(--sp-md2)*1.5094) calc(var(--sp-md2)*1.2264) calc(var(--sp-md2)*0.9433) calc(var(--sp-md2)*1.415)',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box'
    },
    '& .msg-bubble': {
      maxWidth: '75%',
      padding: 'var(--sp-xs) var(--sp-md2)',
      borderRadius: 'var(--sp-md2)',
      wordBreak: 'break-word',
      boxShadow: '0 1px 2px rgba(0,0,0,0.08)'
    },
    '& .msg-bubble.msg-bubble--me': {
      backgroundColor: '#DCF8C6',
      borderBottomRightRadius: 'var(--sp-xxs)'
    },
    '& .msg-bubble.msg-bubble--other': {
      backgroundColor: '#E2E8F0',
      borderBottomLeftRadius: 'var(--sp-xxs)'
    },
    '& .msg-avatar': {
      width: '28px',
      height: '28px',
      minWidth: '28px',
      borderRadius: '50%',
      backgroundColor: '#6B7280',
      color: '#fff',
      fontSize: 'var(--fs-sm)',
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .msg-sender': {
      fontSize: 'var(--fs-xs)',
      fontWeight: 600,
      color: '#6E6F81',
      marginBottom: 'var(--sp-xxs)'
    },
    '& .msg-time': {
      fontSize: 'var(--fs-xs)',
      color: '#9CA3AF'
    }
  },
  '& .details-container': {
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  '& .table-container': {
    maxHeight: '20vh',
    overflowY: 'auto',
    scrollbarWidth: 'thick',
    scrollbarColor: ' rgba(223, 227, 235, 1) #F5F4F9',
    '&::-webkit-scrollbar': {
      // width: '8px',
      // height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(223, 227, 235, 1)'
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(223, 227, 235, 1)',
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(223, 227, 235, 1)'
    },
    '&::-webkit-scrollbar-button': {
      display: 'none !important',
      width: 0,
      height: 0
    }
  }
}));

export const StartButton = styled(Button)(({ theme }) => ({
  borderRadius: 'var(--sp-md2)',
  border: '1px solid #6B7280',
  padding: '7px 29px',
  width: '100%',
  textAlign: 'center',
  fontSize: 'var(--fs-md)',
  fontWeight: '600',
  color: '#6B7280',
  textTransform: 'uppercase',
  cursor: 'pointer'
}));

export const SendButton = styled(Button)(({ theme, disabled, width = '100%' }) => {
  const whiteLabel = useSelector((state) => state.User?.branding);
  const enabledBg = whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218';
  const disabledBg = '#DBDBDB';
  return {
    borderRadius: 'var(--sp-md2)',
    boxShadow: disabled ? 'none' : '0px 4px 10px 0px #B9830940',
    padding: 'calc(var(--sp-xs)*2) calc(var(--sp-md2)*2.9)',
    background: disabled ? disabledBg : enabledBg,
    color: disabled ? '#8a8888' : '#fff',
    width,
    textAlign: 'center',
    fontSize: 'var(--fs-md)',
    fontWeight: '600',
    textTransform: 'uppercase',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.7 : 1,
    ':hover': {
      background: disabled ? disabledBg : enabledBg,
      color: disabled ? '#A0A0A0' : 'white'
    }
  };
});

export const ReplyButton = styled(Button)(({ theme }) => {
  const whiteLabel = useSelector((state) => state.User?.branding);
  return {
    minWidth: 'calc(var(--sp-lg) * 3.5)',
    borderRadius: 'var(--sp-xs)',
    boxShadow: '0px 4px 10px 0px #B9830940',
    padding: 'var(--sp-xxs) calc(var(--sp-md2)*1.5)',
    background: whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218',
    color: 'white',
    textAlign: 'center',
    fontSize: 'var(--fs-md)',
    fontWeight: '600',
    textTransform: 'uppercase',
    cursor: 'pointer',
    ':hover': {
      background: whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218',
      color: 'white'
    }
  };
});

export const FormActionButton = styled(Button)(({ theme }) => {
  const whiteLabel = useSelector((state) => state.User?.branding);
  return {
    background: `linear-gradient(222.6deg, ${
      whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218'
    } 0%, ${whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218'} 100%)`,
    borderRadius: '5px',
    width: '100%',
    boxShadow: '0px 4px 4px 0px #B9830917',
    padding: '0',
    textAlign: 'center',
    color: '#fff !important'
  };
});

export const OdFontScale = styled('span')(({ theme, fontSize, weight, color }) => ({
  fontSize: fontSize || 'var(--fs-md)',
  fontWeight: weight || 500,
  color: color || '#111827'
}));
